/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './nos-business-sign-up';

const NosBusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({
    id,
    wrapper,
    label,
    errorMessage,
    input,
    isAddressInput,
    isValidateVatButton,
    isSectionHeader
}) => {
    // Do not render customerSource dropdown if intern
    if (id === 'OriginOfInterest') {
        const referralCode = (input as React.ReactElement)?.props.children.props.selectedValue.referralCode;
        const isIntern = referralCode !== undefined;
        if (isIntern) {
            return <Node {...wrapper}></Node>;
        }
    }

    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isValidateVatButton && !isSectionHeader && label}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

const NosBusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <NosBusinessSignUpItem key={item.id} {...item} />;
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {disclaimer}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return (
                                <div className='col-12' key={index}>
                                    {button}
                                </div>
                            );
                        })}
                </Node>
            </Node>
        </Module>
    );
};

export default NosBusinesSignUpView;
